import { createFeatureSelector, createSelector } from '@ngrx/store';

import { InventoryState } from './inventory.reducers';

export const selectInventoryState = createFeatureSelector<InventoryState>('inventory');

export const selectInventorySummary = createSelector(selectInventoryState, (invState) => invState.summary);

export const selectInvSumFilter = createSelector(selectInventorySummary, (summary) => summary.filter);

export const selectInvSumShowing = createSelector(selectInventorySummary, (summary) => summary.showing);

export const selectInvSumSelectedRow = createSelector(selectInventorySummary, (summary) => summary.invSumSelectedRow);

export const selectInventoryDetail = createSelector(selectInventoryState, (invState) => invState.detail);

export const selectInvDtlShowing = createSelector(selectInventoryDetail, (detail) => detail.showing);

export const selectInvDtlSelectedRow = createSelector(selectInventoryDetail, (detail) => detail.invDtlSelectedRow);

export const selectInventoryLot = createSelector(selectInventoryState, (invState) => invState.lot);

export const selectInvLotShowing = createSelector(selectInventoryLot, (lot) => lot.showing);

export const inventoryItemLotRequiredVal = createSelector(selectInventoryState, (invState) => invState.lotrequired);
